// @flow
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {
  compose,
  withHandlers,
  lifecycle,
} from 'recompose';
import { createStructuredSelector } from 'reselect';
import {
  reduxForm,
  change,
} from 'redux-form';

import { confirmNegotiate } from '../../../application/signals';
import { isAfternicInBaket } from '../../../domain/selectors';
import Negotiate from './Negotiate';

const mapStateToProps = createStructuredSelector({
  afternicInBasket: isAfternicInBaket,
});
const mapDispatchToProps = (dispatch) => bindActionCreators({
  confirm: confirmNegotiate,
  change,
}, dispatch);
const mergeProps = (stateProps, dispatchProps, ownProps) => {
  return {
    ...stateProps,
    ...ownProps,
    actions: {
      ...dispatchProps,
      ...ownProps.actions,
    },
  };
};

const enhance = compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps,
  ),
  withHandlers({
    onSubmit: (props) => () => {
      return new Promise(() => {
        props.actions.confirm(props.fqdn);
      });
    },
    onCancel: (props) => () => {
      props.actions.closeModal();
    },
  }),
  reduxForm({
    form: 'negotiate',
    propNamespace: 'form',
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions.change('negotiate', 'fqdn', this.props.fqdn);
    },
  }),
);

export default enhance(Negotiate);
